import { create } from "zustand/react";

interface DocsStoreI {
  isOpen: boolean;
  spaceId: string;
  path: string;
  actions: {
    setIsOpen: (isOpen: boolean) => void;
    setSpaceId: (spaceId: string) => void;
    setPath: (path: string) => void;
  };
}

export const useDocsStore = create<DocsStoreI>()((set) => ({
  isOpen: false,
  spaceId: "",
  path: "",
  actions: {
    setIsOpen: (isOpen: boolean) => set({ isOpen }),
    setSpaceId: (spaceId: string) => set({ spaceId }),
    setPath: (path: string) => set({ path }),
  },
}));

/**
 * As Zustand's core is not tied to React's rendering mechanism, it allows to
 * update the store by directly calling store state updates from anywhere.
 */

export const openDocsSidebar = () =>
  useDocsStore.getState().actions.setIsOpen(true);

export const closeDocsSidebar = () =>
  useDocsStore.getState().actions.setIsOpen(false);

export const setDocsSpaceId = (spaceId: string) =>
  useDocsStore.getState().actions.setSpaceId(spaceId);

export const setDocsPath = (path: string) =>
  useDocsStore.getState().actions.setPath(path);
